import Vue from "vue";
import VueRouter from "vue-router";
import LeftYellowLayout from "../layouts/LeftYellowLayout.vue";
import BrowseLayout from "../layouts/BrowseLayout.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
// import HasHeaderLayout from "../layouts/HasHeaderLayout.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LeftYellowLayout",
    redirect: "/home",
    component: LeftYellowLayout,
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue"),
      }
    ],
  },
  {
    path: "/browse",
    name: "BrowseLayout",
    redirect: "/browse/search",
    component: BrowseLayout,
    children: [
      {
        path: "/browse/search",
        name: "SearchResults",
        component: () => import("../views/SearchResults.vue"),
      },
      {
        path: "/browse/:serviceId/providers/:id",
        name: "ProviderDetail",
        component: () => import("../views/ProviderDetail.vue"),
      }
    ],
  },
  {
    path: "/providers",
    name: "LeftYellowLayout",
    component: LeftYellowLayout,
    children: [
      {
        path: "/",
        name: "NewProvider",
        component: () => import("../views/NewProvider.vue")
      }
    ],
  },
  {
    path: "/",
    name: "DefaultLayout",
    component: DefaultLayout,
    children: [
      {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: () => import("../views/PrivacyPolicy.vue")
      },
      {
        path: "/faqs",
        name: "Faqs",
        component: () => import("../views/Faqs.vue")
      },
      {
        path: "/terms-of-use",
        name: "TermsOfUse",
        component: () => import("../views/TermOfUse.vue")
      }
    ],
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});   

export default router;
